/*
回数をカウントしたいプロパティについて
-----------------------------------------------------
RN で使用している xxx_COUNT は使わず、下記のイベント名を使って
そのままユーザーの Property をインクリメントしていけば良い。
例：
Mixpanel.people.increment(RESORT_SHOWN, 1);
*/

/*
イベント名のルール
-----------------------------------------------------
actions:
何が + 何された => 主語 + 過去分詞形
be動詞は省略してください。

あまり固有なものをつくらず、なるべく汎用的な名前を使ったほうが
計測に役立つものになるかと思いますが、迷ったら相談しましょう。
例：
GOOD: TrackingEvents.ELEMENT_TAPPED, { element: 'Reservation Button' }
BAD:  TrackingEvents.PURCHASED_BUTTON_TAPPED
*/

const eventNames = [
  'USER_PARTICIPATED', // { participatedIn: String } ユーザーがイベント等に参加したことを追跡する
  'CREDIT_CARD_ADDED',
  'ITEM_ADDED_TO_CART',
  'ITEM_PURCHASED',
  'ELEMENT_TAPPED',
  'CART_SHOWN',
  'SNOW_SEARCH_SUGGESTION_SELECTED',
  'SNOW_SEARCH_ITEM_SUGGESTION_SELECTED',
];

const titleize = word => (
  word.charAt(0) + word.toLowerCase().slice(1)
);

const trackingEvents = {};

eventNames.forEach((name) => {
  trackingEvents[name] = `WebSnow ${name.split('_').map(n => titleize(n)).join(' ')}`;
});

// PageViewは2017-2018シーズンとの互換性から例外的なネーミング
trackingEvents.PAGE_VIEW = 'WebSnow PageView';

export default trackingEvents;
